module.exports = __webpack_public_path__ + "fonts/PwZc-YbIL414wB9rB1IAPYX0hVgzZQUfRDuZrPvH3D8.woff2";